import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import merge from "lodash/merge";

import union from "lodash/union";

import { hydrate } from "@/lib";
import { fetchSiteFeatures } from "./thunk";

export interface SiteFeaturesState {
  siteFeatures: {
    features?: Array<string>;
    rules?: { [key: string]: unknown };
  };
  error: string | null;
  status: "idle" | "fetching" | "saving";
}

const initialState: SiteFeaturesState = {
  siteFeatures: {},
  status: "idle",
  error: null
};

export const siteFeaturesSlice = createSlice({
  name: "siteFeatures",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(hydrate, (state, action: PayloadAction<string>) => {
        return {
          ...state,
          ...action.payload[siteFeaturesSlice.name]
        };
      })
      .addCase(fetchSiteFeatures.pending, (state) => {
        state.status = "fetching";
      })
      .addCase(
        fetchSiteFeatures.fulfilled,
        (state, action: PayloadAction<any>) => {
          // TODO: remove this once the api structure changes
          const features: Array<string> = [];
          const rules = [];

          action.payload.forEach(({ baseFeature }) => {
            features.push(baseFeature.features);
            rules.push(baseFeature.rules);
          });

          const siteFeatures = {
            // @ts-ignore
            rules: merge(...rules),
            features: union(...features)
          };

          state.status = "idle";
          state.error = null;
          state.siteFeatures = siteFeatures;
        }
      )
      .addCase(fetchSiteFeatures.rejected, (state, action) => {
        state.status = "idle";
        state.error = action.error.message;
      });
  }
});
